/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SignupDto } from '../../models/signup-dto';
import { SignupResponseDto } from '../../models/signup-response-dto';

export interface Signup$Params {
  body: SignupDto;
}

export function signup(
  http: HttpClient,
  rootUrl: string,
  params: Signup$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SignupResponseDto>> {
  const rb = new RequestBuilder(rootUrl, signup.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SignupResponseDto>;
      }),
    );
}

signup.PATH = '/auth/signup';
